var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNmPatternMapL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-pattern-map-nm-cls-1 {\n        fill: #1e1e1e;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-1, .dummy-widget-pattern-map-nm-cls-2, .dummy-widget-pattern-map-nm-cls-3, .dummy-widget-pattern-map-nm-cls-4, .dummy-widget-pattern-map-nm-cls-5, .dummy-widget-pattern-map-nm-cls-6, .dummy-widget-pattern-map-nm-cls-7, .dummy-widget-pattern-map-nm-cls-8, .dummy-widget-pattern-map-nm-cls-9 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-10 {\n        clip-path: url(#dummy-widget-pattern-map-nm-clippath);\n      }\n\n      .dummy-widget-pattern-map-nm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-3 {\n        fill: #3869b0;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-11 {\n        clip-path: url(#dummy-widget-pattern-map-nm-clippath-1);\n      }\n\n      .dummy-widget-pattern-map-nm-cls-4 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-5 {\n        fill: #444;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-6 {\n        fill: #2b2b2b;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-7 {\n        fill: #4b494a;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-8 {\n        fill: #fff;\n      }\n\n      .dummy-widget-pattern-map-nm-cls-9 {\n        fill: #1f1f1f;\n        isolation: isolate;\n        opacity: .7;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-pattern-map-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-2",
    x: 7.2,
    y: 7.6,
    width: 155.5,
    height: 155.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-pattern-map-nm-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-2",
    x: 11.1,
    y: 39.5,
    width: 94.8,
    height: 91.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-4",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-pattern-map-nm-cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 7,
    y: 33.4,
    width: 155.2,
    height: 103.2,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-6",
    d: "M156,136.8H13.3c-3.6,0-6.4-2.9-6.4-6.4V39.6c0-3.6,2.9-6.4,6.4-6.4h142.7c3.6,0,6.4,2.9,6.4,6.4v90.7c0,3.6-2.9,6.4-6.4,6.4h0ZM13.3,33.6c-3.3,0-6,2.7-6,6v90.7c0,3.3,2.7,6,6,6h142.7c3.3,0,6-2.7,6-6V39.6c0-3.3-2.7-6-6-6H13.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-pattern-map-nm-cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 7.5,
    y: 31.9,
    width: 155.6,
    height: 102.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-6",
    d: "M156.8,134.4H13.8c-3.6,0-6.4-2.9-6.4-6.4V38.1c0-3.6,2.9-6.4,6.4-6.4h143.1c3.6,0,6.4,2.9,6.4,6.4v89.8c0,3.6-2.9,6.4-6.4,6.4h-.1ZM13.8,32.1c-3.3,0-6,2.7-6,6v89.8c0,3.3,2.7,6,6,6h143.1c3.3,0,6-2.7,6-6V38.1c0-3.3-2.7-6-6-6H13.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-5",
    x: 15.5,
    y: 39.7,
    width: 140.4,
    height: 86.8,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 15.5,
    y: 95.1,
    width: 140.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 27.2,
    y: 39.7,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 56.3,
    y: 39.7,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 71.4,
    y: 39.7,
    width: 5,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 129.2,
    y: 39.7,
    width: 5,
    height: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 56.8,
    y: 68.8,
    width: 34.2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 27.2,
    y: 109.7,
    width: 34.2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 85.5,
    y: 39.7,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 114.6,
    y: 39.7,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 143.8,
    y: 39.7,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 27.2,
    y: 102.3,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 56.3,
    y: 102.3,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 85.5,
    y: 102.3,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 114.6,
    y: 102.3,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-1",
    x: 143.8,
    y: 102.3,
    width: 5,
    height: 24.1
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    x: 114.2,
    y: 39.5,
    width: 5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    x: 143.3,
    y: 39.5,
    width: 5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    x: 114.2,
    y: 102.8,
    width: 5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    x: 143.3,
    y: 102.8,
    width: 5,
    height: 24.3
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    cx: 92.8,
    cy: 102.3,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    cx: 82.2,
    cy: 71.9,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    cx: 27,
    cy: 50.8,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    cx: 26.9,
    cy: 112.2,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    d: "M28.1,53.6h-1.5v-4.7l-1.4.4v-1.1l2.8-1h.1v6.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    d: "M84.4,74.6h-4.4v-1l2-2.1c.5-.6.8-1,.8-1.4s0-.5-.2-.6c0,0-.3-.2-.5-.2s-.4,0-.5.3-.2.4-.2.7h-1.5c0-.4,0-.7.3-1.1.2-.3.5-.6.8-.8.3-.2.7-.3,1.2-.3s1.2.2,1.6.5.6.8.6,1.4,0,.5,0,.7c0,.2-.2.5-.4.7-.2.3-.5.6-.9,1l-.8.9h2.5v1.1l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    d: "M28.6,112.6h.6v1.1h-.6v1.3h-1.5v-1.3h-2.4v-.9l2.4-4.1h1.5v3.8h0ZM26,112.6h1.1v-1.9h0c0,0-1,1.9-1,1.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-8",
    d: "M92,101.7h.7c.5,0,.8-.3.8-.8s0-.4-.2-.5c0,0-.3-.2-.6-.2s-.4,0-.5.2c0,0-.2.3-.2.4h-1.5c0-.3,0-.6.3-.9.2-.3.4-.5.8-.6.3,0,.7-.2,1.1-.2.7,0,1.3.2,1.7.5.4.3.6.8.6,1.3s0,.5-.2.8c-.2.2-.4.4-.7.6.3,0,.6.3.8.6.2.2.3.6.3.9,0,.6-.2,1-.7,1.3-.4.3-1,.5-1.7.5s-.8,0-1.2-.2c-.4-.2-.6-.4-.8-.7-.2-.3-.3-.6-.3-1h1.5c0,.2,0,.4.2.5s.3.2.6.2.5,0,.6-.2.2-.3.2-.5c0-.3,0-.5-.2-.7-.2,0-.4-.2-.7-.2h-.7v-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-9",
    d: "M13.1-82.8h143.4c3.4,0,6.1,2.8,6.1,6.2V13.9c0,3.4-2.8,6.2-6.1,6.2H13.1c-3.4,0-6.1-2.8-6.1-6.2v-90.5c0-3.4,2.8-6.2,6.1-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-9",
    x: 7,
    y: 149.8,
    width: 157,
    height: 99.8,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 112.3,
    y: 42.8,
    width: 44.4,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 58.1,
    width: 28.8,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 64.8,
    width: 24.2,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    d: "M115.2,65.4h-1.5v-4.7l-1.4.4v-1.1l2.8-1h0v6.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 76.1,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 82.8,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    d: "M116.3,83.1h-4.4v-1l2-2.1c.5-.6.8-1,.8-1.4s0-.5-.2-.6c0,0-.3-.2-.5-.2s-.4,0-.5.3c0,.2-.2.4-.2.7h-1.5c0-.4,0-.7.3-1.1.2-.3.5-.6.8-.8.3-.2.7-.3,1.2-.3s1.2.2,1.6.5.6.8.6,1.4,0,.5,0,.7c0,.2-.2.5-.4.7-.2.3-.5.6-.9,1l-.8.9h2.5v1.1l-.3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 94.1,
    width: 28.8,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 118.4,
    y: 100.8,
    width: 22.9,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    d: "M113.3,98.2h.7c.5,0,.8-.3.8-.8s0-.4-.2-.5c0,0-.3-.2-.6-.2s-.4,0-.5.2c0,0-.2.3-.2.4h-1.5c0-.3,0-.6.3-.9.2-.3.4-.5.8-.6.3,0,.7-.2,1.1-.2.7,0,1.3.2,1.7.5.4.3.6.8.6,1.3s0,.5-.2.8c-.2.2-.4.4-.7.6.3,0,.6.3.8.6.2.2.3.6.3.9,0,.6-.2,1-.7,1.3-.4.3-1,.5-1.7.5s-.8,0-1.2-.2c-.4-.2-.6-.4-.8-.7-.2-.3-.3-.6-.3-1h1.5c0,.2,0,.4.2.5s.3.2.6.2.5,0,.6-.2.2-.3.2-.5c0-.3,0-.5-.2-.7-.2,0-.4-.2-.7-.2h-.7v-1.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 119.1,
    y: 112.1,
    width: 27.9,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-pattern-map-nm-cls-7",
    x: 119.1,
    y: 118.8,
    width: 13.1,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-pattern-map-nm-cls-3",
    d: "M115.8,117.2h.6v1.1h-.6v1.3h-1.5v-1.3h-2.4v-.9l2.4-4.1h1.5v3.8h0ZM113.2,117.2h1.1v-1.9h0c0,0-1,1.9-1,1.9h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmPatternMapL);
export default __webpack_public_path__ + "static/media/nm_pattern_map_l.937de174.svg";
export { ForwardRef as ReactComponent };